(function () {
  var isHome = document.body && document.body.classList.contains('template-index');
  if (!isHome) return;

  document.documentElement.classList.add('gelly-homepage-js');

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero background slideshow fallback */
  document.querySelectorAll('[data-gelly-hero-slideshow]').forEach(function (slideshow) {
    if (slideshow.dataset.gellySlideshowBound === 'true') return;
    var slides = slideshow.querySelectorAll('.gelly-hero-slideshow__slide');
    if (slides.length < 2 || reducedMotion) return;

    slideshow.dataset.gellySlideshowBound = 'true';
    var index = 0;
    var interval = parseInt(slideshow.getAttribute('data-interval') || '3000', 10);

    window.setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);
  });

  function showAll(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (!reducedMotion) {
    var revealEls = document.querySelectorAll('.gelly-reveal, [data-gelly-reveal]');
    if (revealEls.length && 'IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
      );

      revealEls.forEach(function (el, index) {
        var delay = el.getAttribute('data-reveal-delay');
        if (!delay) {
          delay = el.closest('[data-gelly-stagger]')
            ? String(Math.min(index * 0.08, 0.4))
            : String(Math.min(index * 0.04, 0.2));
        }
        el.style.transitionDelay = delay + 's';
        revealObserver.observe(el);
      });

      window.setTimeout(function () {
        showAll('.gelly-reveal, [data-gelly-reveal]');
      }, 3000);
    }
  } else {
    showAll('.gelly-reveal, [data-gelly-reveal]');
  }

  /* Collection carousel — loop + autoplay */
  document.querySelectorAll('[data-gelly-collection-carousel]').forEach(function (carousel) {
    var viewport = carousel.querySelector('[data-gelly-carousel-viewport]');
    var track = carousel.querySelector('[data-gelly-carousel-track]');
    var prev = carousel.querySelector('[data-gelly-carousel-prev]');
    var next = carousel.querySelector('[data-gelly-carousel-next]');
    if (!viewport || !track) return;

    var slides = track.querySelectorAll('.gelly-collection-carousel__slide');
    if (!slides.length) return;

    var index = 0;
    var timer = null;
    var AUTOPLAY_MS = 2000;

    function getVisible() {
      if (window.innerWidth >= 990) return 4;
      if (window.innerWidth >= 550) return 2;
      return 1;
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getVisible());
    }

    function getStep() {
      var slide = slides[0];
      if (!slide) return 0;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return slide.offsetWidth + gap;
    }

    function layoutSlides() {
      var visible = getVisible();
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      var slideWidth = (viewport.clientWidth - gap * (visible - 1)) / visible;

      slides.forEach(function (slide) {
        slide.style.flexBasis = slideWidth + 'px';
        slide.style.width = slideWidth + 'px';
      });
    }

    function applyTransform(animate) {
      var offset = index * getStep();
      if (!animate || reducedMotion) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      if (!animate || reducedMotion) {
        void track.offsetHeight;
        if (!reducedMotion) track.style.transition = '';
      }
    }

    function goTo(nextIndex, animate) {
      var maxIndex = getMaxIndex();
      if (maxIndex === 0) {
        index = 0;
        applyTransform(false);
        if (prev) prev.disabled = true;
        if (next) next.disabled = true;
        return;
      }

      var wrap = false;
      if (nextIndex > maxIndex) {
        nextIndex = 0;
        wrap = true;
      } else if (nextIndex < 0) {
        nextIndex = maxIndex;
        wrap = true;
      }

      index = nextIndex;
      applyTransform(animate && !wrap);

      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }

    function advance(dir) {
      goTo(index + dir, true);
    }

    function startAutoplay() {
      stopAutoplay();
      if (reducedMotion || getMaxIndex() === 0) return;
      timer = window.setInterval(function () {
        advance(1);
      }, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stopAutoplay();
        advance(-1);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        stopAutoplay();
        advance(1);
        startAutoplay();
      });
    }

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    window.addEventListener('resize', function () {
      layoutSlides();
      applyTransform(false);
    });

    layoutSlides();
    goTo(0, false);
    startAutoplay();
  });

  /* Bestseller cinema carousel — synced image + details */
  document.querySelectorAll('[data-gelly-bestseller-carousel]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gelly-bestseller-slide]'));
    var details = Array.prototype.slice.call(root.querySelectorAll('[data-gelly-bestseller-detail]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gelly-bestseller-dot]'));
    var prev = root.querySelector('[data-gelly-bestseller-prev]');
    var next = root.querySelector('[data-gelly-bestseller-next]');
    var media = root.querySelector('[data-gelly-bestseller-media]');
    var count = slides.length;

    if (count < 1) return;

    var index = 0;
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && count > 1 && !reducedMotion;
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);

    function setTabbable(container, active) {
      if (!container) return;
      container.querySelectorAll('a, button').forEach(function (el) {
        if (active) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    function goTo(nextIndex) {
      if (count < 2) return;
      var nextSafe = ((nextIndex % count) + count) % count;
      if (nextSafe === index) return;

      var prevSlide = slides[index];
      var prevDetail = details[index];

      if (prevSlide) {
        prevSlide.classList.remove('is-active');
        prevSlide.classList.add('is-exit');
        prevSlide.setAttribute('aria-hidden', 'true');
        setTabbable(prevSlide, false);
        window.setTimeout(function () {
          prevSlide.classList.remove('is-exit');
        }, reducedMotion ? 0 : 560);
      }

      if (prevDetail) {
        prevDetail.classList.remove('is-active');
        prevDetail.setAttribute('aria-hidden', 'true');
        setTabbable(prevDetail, false);
      }

      index = nextSafe;

      var activeSlide = slides[index];
      var activeDetail = details[index];

      if (activeSlide) {
        activeSlide.classList.add('is-active');
        activeSlide.setAttribute('aria-hidden', 'false');
        setTabbable(activeSlide, true);
      }

      if (activeDetail) {
        activeDetail.classList.add('is-active');
        activeDetail.setAttribute('aria-hidden', 'false');
        setTabbable(activeDetail, true);
      }

      dots.forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    function advance(dir) {
      goTo(index + dir);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay) return;
      timer = window.setInterval(function () {
        advance(1);
      }, interval);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stopAutoplay();
        advance(-1);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        stopAutoplay();
        advance(1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-index') || '0', 10);
        stopAutoplay();
        goTo(target);
        startAutoplay();
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        stopAutoplay();
        advance(-1);
        startAutoplay();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        stopAutoplay();
        advance(1);
        startAutoplay();
      }
    });

    if (media) {
      var touchStartX = 0;
      var touchStartY = 0;
      media.addEventListener(
        'touchstart',
        function (event) {
          touchStartX = event.changedTouches[0].screenX;
          touchStartY = event.changedTouches[0].screenY;
          stopAutoplay();
        },
        { passive: true }
      );
      media.addEventListener(
        'touchend',
        function (event) {
          var dx = event.changedTouches[0].screenX - touchStartX;
          var dy = event.changedTouches[0].screenY - touchStartY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            advance(dx < 0 ? 1 : -1);
          }
          startAutoplay();
        },
        { passive: true }
      );
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    details.forEach(function (detail, i) {
      setTabbable(detail, i === 0);
    });
    slides.forEach(function (slide, i) {
      setTabbable(slide, i === 0);
    });

    startAutoplay();
  });

  /* Lifestyle uses a fixed clipped image — no JS parallax */

  /* Testimonials carousel — scroll, loop, autoplay */
  document.querySelectorAll('[data-gelly-testimonials-carousel]').forEach(function (carousel) {
    var viewport = carousel.querySelector('[data-gelly-testimonials-viewport]');
    var track = carousel.querySelector('[data-gelly-testimonials-track]');
    var prev = carousel.querySelector('[data-gelly-testimonials-prev]');
    var next = carousel.querySelector('[data-gelly-testimonials-next]');
    if (!viewport || !track) return;

    var originalSlides = Array.prototype.slice.call(
      track.querySelectorAll('.gelly-testimonials-carousel__slide')
    );
    if (!originalSlides.length) return;

    // Duplicate slides so we can always scroll/loop even with few reviews
    originalSlides.forEach(function (slide) {
      var clone = slide.cloneNode(true);
      clone.removeAttribute('id');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[id]').forEach(function (el) {
        el.removeAttribute('id');
      });
      track.appendChild(clone);
    });

    var slides = track.querySelectorAll('.gelly-testimonials-carousel__slide');
    var index = 0;
    var timer = null;
    var AUTOPLAY_MS = parseInt(carousel.getAttribute('data-interval') || '3500', 10);

    function getViewportInnerWidth() {
      var styles = window.getComputedStyle(viewport);
      var padX =
        (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
      return Math.max(0, viewport.clientWidth - padX);
    }

    function getVisible() {
      if (window.innerWidth >= 990) return Math.min(3, originalSlides.length);
      if (window.innerWidth >= 750) return Math.min(2, originalSlides.length);
      return 1;
    }

    function getStep() {
      var slide = slides[0];
      if (!slide) return 0;
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function layoutSlides() {
      var visible = getVisible();
      var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      var innerWidth = getViewportInnerWidth();
      var slideWidth = (innerWidth - gap * (visible - 1)) / visible;

      slides.forEach(function (slide) {
        slide.style.flexBasis = slideWidth + 'px';
        slide.style.width = slideWidth + 'px';
        slide.style.maxWidth = slideWidth + 'px';
      });
    }

    function applyTransform(animate) {
      var offset = index * getStep();
      if (!animate || reducedMotion) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
      if (!animate || reducedMotion) {
        void track.offsetHeight;
        if (!reducedMotion) track.style.transition = '';
      }

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    }

    function goTo(nextIndex, animate) {
      var loopCount = originalSlides.length;
      if (loopCount === 0) return;

      if (nextIndex >= loopCount) {
        // Animate into the cloned set, then snap back
        index = nextIndex;
        applyTransform(animate);
        window.setTimeout(
          function () {
            index = nextIndex % loopCount;
            applyTransform(false);
          },
          reducedMotion ? 0 : 560
        );
        return;
      }

      if (nextIndex < 0) {
        index = loopCount + nextIndex;
        applyTransform(false);
        window.requestAnimationFrame(function () {
          applyTransform(true);
        });
        return;
      }

      index = nextIndex;
      applyTransform(animate);
    }

    function advance(dir) {
      goTo(index + dir, true);
    }

    function startAutoplay() {
      stopAutoplay();
      if (reducedMotion || originalSlides.length < 2) return;
      timer = window.setInterval(function () {
        advance(1);
      }, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        stopAutoplay();
        advance(-1);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        stopAutoplay();
        advance(1);
        startAutoplay();
      });
    }

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    var touchStartX = 0;
    viewport.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.changedTouches[0].screenX;
        stopAutoplay();
      },
      { passive: true }
    );
    viewport.addEventListener(
      'touchend',
      function (event) {
        var dx = event.changedTouches[0].screenX - touchStartX;
        if (Math.abs(dx) > 40) advance(dx < 0 ? 1 : -1);
        startAutoplay();
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      layoutSlides();
      if (index >= originalSlides.length) index = 0;
      applyTransform(false);
    });

    layoutSlides();
    goTo(0, false);
    startAutoplay();
  });
})();
